var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Path_1",
    "data-name": "Path 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.189,
    height: 304.189,
    viewBox: "0 0 304.189 304.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f9bd36;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-1",
    d: "M152.094,0A152.094,152.094,0,1,0,304.189,152.094,152.094,152.094,0,0,0,152.094,0Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-2",
    d: "M152.094,30.419a121.675,121.675,0,0,1,0,243.351,119.9,119.9,0,0,1-83.032-32.732c-24.92-23.655-38.643-55.243-38.643-88.943A121.813,121.813,0,0,1,152.094,30.419m0-30.419A152.094,152.094,0,0,0,0,152.094c0,43.428,18.2,82.6,48.12,111A152.094,152.094,0,1,0,152.094,0Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.7418b261c331cc5d67541a4857997faa.svg";
export { ForwardRef as ReactComponent };